import _ from 'lodash';
import { createTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';

import components from './Components';
import typography from './Typography';
import { shadows, darkshadows } from './Shadows';
import { DarkThemeColors } from './DarkThemeColors';
import { LightThemeColors } from './LightThemeColors';
import { baseDarkTheme, baselightTheme } from './DefaultColors';
import { tokens } from './Tokens';

// Pure on purpose — no hooks, no Redux — so the expensive part can sit behind a useMemo in
// Theme.tsx, and so app/ pages can build the theme without pulling in the store.
// Exported so paletteContract.test.ts can build a theme directly, without a component
// tree or a Redux store, to assert token values for every named theme and both modes.
// eslint-disable-next-line import/prefer-default-export
export const composeTheme = (
  themeName: string,
  direction: string,
  activeMode: string,
  borderRadius: number,
) => {
  const themeOptions = LightThemeColors.find((theme) => theme.name === themeName);
  const darkthemeOptions = DarkThemeColors.find((theme) => theme.name === themeName);
  const defaultTheme = activeMode === 'dark' ? baseDarkTheme : baselightTheme;
  const defaultShadow = activeMode === 'dark' ? darkshadows : shadows;
  const themeSelect = activeMode === 'dark' ? darkthemeOptions : themeOptions;
  const baseMode = {
    palette: {
      mode: activeMode,
    },
    shape: {
      borderRadius,
    },
    shadows: defaultShadow,
    typography,
  };
  const theme = createTheme(
    _.merge({}, baseMode, defaultTheme, locales, themeSelect, { direction }, { tokens }),
  );
  theme.components = components(theme);

  return theme;
};
